import React from "react";
import ComponentLayoutWrapper from "../core/ComponentLayoutWrapper";
import { Box, Grid, Typography } from "@mui/material";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import { RootState, useAppSelector } from "src/store/store";
import { StyledSwitches } from "../emailPreferences/styles";
import { SwitchLabelStyles } from "../common/SecondarySwitch";

export default function HideLowBalances({
  hideLowHoldings,
}: {
  hideLowHoldings: (event: React.ChangeEvent<HTMLInputElement> | null, checked: boolean) => void;
}) {
  const switchClasses = SwitchLabelStyles();
  const { walletHideLowBalances } = useAppSelector((state: RootState) => state.settings);

  return (
    <ComponentLayoutWrapper
      gridArea="HIDE_LOW_BALANCE"
      state={{}}
      fadeInDirection="none"
      loadingComponent={<></>}>
      <Grid container justifyContent="flex-end" alignItems="center">
        <Box sx={{ display: "flex", alignItems: "center", marginTop: "4px" }}>
          <Typography className={switchClasses.label}>Hide low balances</Typography>
          <StyledSwitches
            id="hide-low-balance"
            checked={walletHideLowBalances}
            onChange={hideLowHoldings}
          />
        </Box>
      </Grid>
    </ComponentLayoutWrapper>
  );
}
